<template>
  <div>
    <search-module-inventory-statistic @submit="submitSearch" />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="module_model_id"
    >
      <span slot="inventory_count" slot-scope="text, record">
        <a @click="showFirmwareVersionModal(record)">{{ text }}</a>
      </span>

      <span slot="is_alarm" slot-scope="text">
        {{ text ? '是' : '否' }}
      </span>

      <span slot="alarm_value" slot-scope="text, record">
        {{ record.is_alarm ? text : '-' }}
      </span>

      <span slot="effective" slot-scope="text">
        {{ text ? '有效' : '无效' }}
      </span>

      <span slot="actions" slot-scope="text, record">
        <a
          v-if="isHasSetAlarmPermission"
          @click="showSetAlarmModal(record.module_model_id, record.is_alarm, record.alarm_type, record.alarm_value)"
        >告警配置</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <set-alarm
      v-if="isShowSetAlarmModal"
      :visible.sync="isShowSetAlarmModal"
      :module-model-id="settingModuleModelId"
      :is-alarm="isAlarm"
      :alarm-type="alarmType"
      :alarm-value="alarmValue"
      @completed="fetchData"
    />

    <firmware-versions
      v-if="isShowFirmwareVersionModal"
      :visible.sync="isShowFirmwareVersionModal"
      :module-model-id="firmwareVersionModuleModelId"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findModuleInventoryStatistics } from '@/api/module_inventory'
import Pagination from '@/components/Pagination'
import SearchModuleInventoryStatistic from '@/views/module_inventories/statistics/Search'

export default {
  name: 'ModuleInventoryStatisticList',
  components: {
    Pagination,
    SearchModuleInventoryStatistic,
    SetAlarm: () => import('@/views/module_inventories/statistics/SetAlarm'),
    FirmwareVersions: () => import('@/views/module_inventories/statistics/FirmwareVersions')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowSetAlarmModal: false,
      settingModuleModelId: 0,
      isAlarm: false,
      alarmType: 1,
      alarmValue: 0,
      isShowFirmwareVersionModal: false,
      firmwareVersionModuleModelId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        { title: '模组厂商', dataIndex: 'module_producer_name', width: 160 },
        { title: '模组型号', dataIndex: 'module_model_name', width: 180 },
        { title: '库存数量', dataIndex: 'inventory_count', width: 120, scopedSlots: { customRender: 'inventory_count' }},
        { title: '是否告警', dataIndex: 'is_alarm', width: 100, scopedSlots: { customRender: 'is_alarm' }},
        { title: '告警数量', dataIndex: 'alarm_value', width: 120, scopedSlots: { customRender: 'alarm_value' }},
        { title: '有效性', dataIndex: 'effective', width: 100, scopedSlots: { customRender: 'effective' }},
        { title: '操作', dataIndex: 'actions', width: 120, scopedSlots: { customRender: 'actions' }}
      ]
    },

    isHasSetAlarmPermission() {
      return hasPermission('module_inventory_statistics/set_alarm') || hasPermission('module_inventories')
    }
  },
  methods: {
    showFirmwareVersionModal(record) {
      this.firmwareVersionModuleModelId = record.module_model_id
      this.isShowFirmwareVersionModal = true
    },

    showSetAlarmModal(moduleModelId, isAlarm, alarmType, alarmValue) {
      this.settingModuleModelId = moduleModelId
      this.isAlarm = isAlarm

      if (isAlarm) {
        this.alarmType = alarmType || 1
        this.alarmValue = alarmValue
      } else {
        this.alarmType = 1
        this.alarmValue = 0
      }

      this.isShowSetAlarmModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findModuleInventoryStatistics(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
